import { takeLatest } from 'redux-saga';
import { take, put, call } from 'redux-saga/effects';

import { loadDataAction,loadDataSuccessAction,loadDataErrorAction } from 'modules/app/actions';
import { deleteVisit as deleteVisitActions } from '../actions';
import { DELETE_VISIT } from '../constants/actionTypes';
import { removeVisit } from '../repository';


function *_deleteVisit(action) {
    const {trac} = action;
    yield put(loadDataAction('deleteVisit'));

    try {
        yield call(removeVisit(trac));
        yield put(deleteVisitActions.success(trac));
        yield put(loadDataSuccessAction('deleteVisit', 'visit.delete.success'));
    } catch (error) {
        yield put(deleteVisitActions.error(error));
        yield put(loadDataErrorAction('deleteVisit', {response: error.response, body: error.body, titleId:'visit.delete.failed'}, action));
    }

}


export function *deleteVisit() {
    yield takeLatest(DELETE_VISIT.REQUEST, _deleteVisit);
}